Oskari.bundle('lang-overrides', function () {
  return Oskari.clazz.create('Oskari.language.Bundle');
});